import { InputHTMLAttributes, useState } from "react";
import "./style.css";
import OpenEye from "../Icons/OpenEye";
import ClosedEye from "../Icons/ClosedEye";

interface YudlInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    containerStyle?: string;
    invalidFeedback?: string;
}

const YudlInput = ({ label, invalidFeedback, containerStyle = "", type = "text", ...props }: YudlInputProps) => {
    const [showpassword, setShowPassword] = useState(false);
    return (
        <div className={`yuld-input-control my-3 ${containerStyle}`}>
            {label && <label className="text-theme yudl-label">{label}</label>}
            <input
                type={showpassword ? "text" : type}
                className="yudl-input text-theme w-100 form-control"
                {...props}
            />
            <small className="invalid-feedback">{invalidFeedback}</small>
            {type === "password" && (
                <span className="yudl-input-eye" onClick={() => setShowPassword(prev => !prev)}>
                    {showpassword ? <OpenEye /> : <ClosedEye />}
                </span>
            )}
        </div>
    );
};

export default YudlInput;
